import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1280.000000 853.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,853.000000) scale(0.100000,-0.100000)">

<path d="M6595 6874 c-246 -19 -454 -60 -655 -129 -41 -14 -97 -34 -125 -43
-52 -17 -349 -165 -375 -186 -8 -7 -40 -27 -70 -45 -62 -38 -259 -183 -260
-192 0 -8 175 -149 185 -149 4 0 39 24 79 54 146 110 309 205 479 281 82 36
284 102 352 114 31 6 60 13 64 16 21 12 347 45 450 45 488 0 968 -159 1358
-449 29 -22 34 -23 50 -10 131 110 162 143 151 156 -34 42 -323 221 -460 287
-247 117 -545 203 -823 235 -102 13 -325 21 -400 15z"/>
<path d="M6510 6419 c-299 -33 -623 -152 -866 -318 -50 -33 -108 -76 -129 -94
l-38 -33 53 -44 c29 -25 71 -62 94 -82 45 -41 67 -46 86 -23 23 27 162 121
250 168 222 120 495 187 756 187 350 0 657 -94 938 -287 l78 -54 32 24 c17 14
62 53 100 89 l69 64 -66 47 c-77 55 -253 157 -335 193 -133 59 -323 118 -472
145 -124 23 -420 33 -550 18z"/>
<path d="M6505 5954 c-49 -8 -100 -18 -112 -24 -12 -5 -50 -17 -84 -25 -71
-19 -203 -80 -299 -140 -64 -39 -78 -49 -127 -90 l-24 -20 101 -88 101 -88 42
34 c87 70 224 134 377 178 74 20 106 24 240 23 155 0 198 -7 330 -50 73 -24
201 -90 252 -128 26 -20 50 -36 53 -36 4 0 51 41 105 92 l99 92 -67 45 c-96
64 -266 149 -347 172 -38 11 -81 25 -95 30 -49 18 -246 39 -349 38 -58 -1
-146 -8 -196 -15z"/>
<path d="M4930 5625 c-471 -95 -872 -252 -1160 -454 -96 -67 -241 -217 -288
-297 -70 -121 -94 -246 -68 -358 52 -223 274 -413 646 -553 149 -55 207 -72
460 -128 80 -18 288 -50 435 -67 148 -17 843 -17 1020 0 564 56 1106 194 1504
383 68 33 126 57 129 54 6 -5 -56 -65 -68 -65 -4 0 -35 -18 -68 -40 -33 -22
-63 -40 -66 -40 -4 0 -33 -12 -64 -26 -31 -15 -75 -34 -97 -44 -58 -25 -229
-73 -390 -110 -201 -45 -214 -50 -120 -44 44 3 103 9 130 14 112 21 304 52
371 60 39 5 126 20 195 34 68 14 137 26 154 26 25 1 28 3 15 13 -8 7 -15 21
-15 32 0 29 -49 31 -127 5 -34 -12 -88 -23 -118 -26 l-55 -4 40 14 c22 8 79
26 126 40 84 25 86 26 99 66 8 23 20 40 29 41 9 1 21 2 26 4 6 1 16 3 22 3 7
1 27 18 44 37 23 25 43 36 76 41 52 8 58 3 66 -49 6 -38 3 -44 -47 -84 -8 -7
-22 -13 -30 -13 -18 0 -26 -21 -21 -58 5 -36 -11 -52 -69 -69 -320 -92 -413
-112 -646 -137 -74 -8 -229 -20 -345 -25 -236 -12 -339 -21 -332 -27 7 -7 788
15 922 26 66 5 206 14 310 19 180 9 195 11 285 44 52 19 146 57 207 86 l112
51 134 0 c129 0 136 1 189 29 61 33 155 63 363 116 126 32 280 84 272 91 -2 2
-30 -5 -64 -16 -94 -29 -176 -36 -204 -16 -13 9 -43 16 -66 16 -43 0 -57 12
-27 24 9 3 35 6 59 6 58 0 217 31 444 86 127 31 187 42 195 34 24 -24 96 -1
96 30 0 38 -81 54 -102 20 -7 -11 -18 -20 -25 -20 -14 0 -192 -41 -418 -96
-77 -19 -151 -34 -165 -34 -23 0 -23 1 -7 17 9 10 63 34 120 55 56 21 89 36
74 33 -16 -3 -62 -13 -104 -21 -57 -12 -82 -13 -99 -5 -35 15 -30 26 19 38 62
16 171 56 178 66 3 4 10 7 15 6 17 -4 64 13 64 23 0 6 7 8 15 5 8 -4 17 -1 21
5 8 12 -84 2 -101 -12 -5 -4 -59 -22 -120 -40 -60 -17 -119 -37 -130 -44 -20
-13 -75 -27 -75 -19 0 2 14 9 30 14 17 6 30 16 30 23 0 21 42 53 115 88 136
66 158 93 38 46 -140 -54 -147 -56 -167 -48 -11 4 -21 11 -23 16 -2 5 52 39
120 75 193 104 531 290 543 300 6 5 33 6 61 2 43 -5 54 -2 72 16 26 26 27 55
1 81 -38 38 -102 21 -125 -35 -13 -29 -45 -49 -292 -181 -399 -212 -410 -217
-429 -210 -16 6 -16 8 2 25 10 10 78 62 149 116 158 119 189 144 183 150 -3 3
-18 -8 -34 -25 -16 -16 -32 -30 -36 -30 -9 0 -115 -65 -215 -131 -59 -39 -83
-49 -112 -48 -20 1 -45 -2 -56 -5 -19 -7 -19 -6 -1 6 35 24 131 102 166 135
19 18 38 33 43 33 4 0 7 4 7 9 0 17 -52 -7 -108 -49 -87 -66 -130 -92 -142
-85 -14 9 -2 24 102 137 47 51 90 97 95 102 32 35 -77 -53 -142 -115 -75 -72
-82 -76 -117 -71 -21 2 -38 7 -38 11 0 4 22 30 48 57 44 44 108 113 215 232
21 23 34 42 29 42 -10 0 -271 -272 -285 -296 -12 -20 -27 -17 -27 6 0 11 -2
20 -5 20 -3 0 -61 -48 -128 -106 -124 -107 -285 -220 -412 -289 -117 -63 -401
-180 -570 -235 -875 -283 -1836 -324 -2655 -113 -202 51 -426 147 -575 245
-101 66 -226 191 -261 260 -86 170 -67 354 53 503 212 264 625 472 1133 571
47 9 87 18 89 20 9 8 -37 2 -149 -21z m3380 -1152 c128 -47 170 -110 170 -255
0 -101 -40 -120 -90 -41 -30 47 -152 142 -217 169 -68 29 -76 87 -17 133 35
28 64 27 154 -6z"/>
<path d="M5105 5594 c-27 -8 -63 -17 -80 -20 -16 -3 -34 -10 -39 -15 -6 -5
-19 -9 -30 -9 -12 0 -34 -9 -51 -20 -32 -21 -60 -27 -50 -10 4 6 -1 7 -11 3
-13 -5 -14 -8 -5 -11 8 -3 4 -9 -11 -17 -15 -8 -29 -9 -42 -2 -12 6 -32 4 -63
-8 -50 -19 -52 -33 -2 -16 18 6 34 9 36 7 2 -2 -29 -16 -69 -31 -178 -68 -332
-168 -451 -295 -82 -87 -101 -124 -95 -191 5 -47 31 -89 56 -89 4 0 15 -14 23
-32 l15 -32 1 66 c2 109 27 175 99 266 87 112 219 209 404 301 110 54 201 95
215 97 6 0 17 4 25 7 8 4 53 18 99 32 46 14 87 27 89 30 8 8 -9 5 -63 -11z"/>
<path d="M6641 5545 c-79 -25 -127 -89 -118 -161 2 -23 14 -52 25 -64 12 -13
19 -28 15 -33 -3 -6 -7 -41 -7 -79 -1 -37 -4 -68 -9 -68 -20 -2 -83 14 -94 23
-9 6 -13 6 -13 -3 0 -7 8 -19 18 -26 14 -11 15 -13 2 -14 -9 0 -21 5 -28 12
-9 9 -12 7 -12 -10 0 -23 -10 -28 -26 -12 -6 6 -20 4 -38 -6 -16 -8 -32 -11
-35 -7 -10 13 -162 15 -192 2 l-29 -11 94 -77 c52 -42 173 -139 270 -215 97
-77 180 -144 183 -150 5 -8 3 -8 -8 0 -8 6 -77 58 -154 116 -277 207 -400 299
-424 318 -13 11 -29 16 -34 13 -6 -3 -7 -1 -4 5 4 5 -16 29 -44 51 -40 32 -55
39 -65 30 -21 -18 -56 -3 -105 43 -45 43 -100 78 -124 78 -10 0 -124 -76 -161
-109 -7 -5 -15 -7 -18 -4 -3 4 -6 1 -6 -6 0 -7 -4 -10 -9 -6 -5 3 -12 1 -15
-4 -3 -4 -18 -11 -33 -14 -16 -3 -50 -27 -78 -54 -45 -44 -288 -251 -387 -330
-22 -18 -57 -48 -79 -68 -21 -19 -42 -35 -47 -35 -4 0 14 19 39 43 120 109
169 156 169 161 0 2 -11 -1 -25 -7 -14 -7 -25 -15 -25 -19 0 -3 -8 -5 -17 -3
-62 13 -73 17 -68 25 3 6 1 10 -4 10 -6 0 -11 -5 -11 -11 0 -5 -4 -7 -10 -4
-6 3 -1 15 11 28 17 19 21 20 30 7 9 -13 10 -12 5 3 -3 9 -2 17 2 17 4 0 23
15 44 33 20 17 75 61 122 96 85 63 95 74 76 86 -5 3 -6 13 -3 23 6 14 4 15 -9
4 -22 -18 -136 -25 -170 -11 -33 13 -34 17 -10 36 19 16 15 15 -40 -7 l-38
-14 2 -120 1 -121 -45 -35 c-25 -19 -71 -53 -102 -75 -62 -43 -274 -198 -291
-213 -6 -5 -24 -17 -40 -28 l-29 -19 114 -7 c63 -4 170 -10 238 -14 l122 -6
44 38 c23 22 76 67 117 101 488 409 565 473 609 507 l38 28 134 -98 c73 -55
176 -132 228 -172 52 -40 129 -99 170 -130 41 -31 184 -143 318 -250 l243
-194 72 69 c40 39 104 99 142 133 39 35 90 82 115 104 88 80 287 253 410 358
l126 106 35 -32 c188 -167 289 -258 369 -334 l95 -90 48 24 c26 14 47 28 47
33 0 13 -260 261 -273 261 -6 0 -1 -9 11 -20 12 -12 22 -23 22 -25 0 -12 -18
-3 -46 23 -16 15 -50 43 -74 62 -24 19 -56 46 -71 60 -33 30 -64 56 -118 100
-46 36 -38 38 -120 -33 -25 -21 -51 -35 -59 -32 -9 3 -12 0 -9 -9 4 -11 1 -13
-10 -9 -11 4 -14 2 -9 -5 4 -7 3 -12 -2 -12 -22 0 -20 16 5 44 21 22 16 20
-17 -9 -62 -53 -183 -160 -244 -216 -96 -86 -309 -263 -305 -253 2 6 51 52
109 104 152 136 250 232 244 242 -3 4 1 5 8 3 19 -8 94 70 77 80 -7 5 -10 4
-6 -2 4 -6 -5 -19 -19 -28 -19 -12 -29 -14 -33 -6 -5 8 -13 5 -26 -9 -18 -19
-85 -29 -85 -12 0 4 -18 6 -40 4 -22 -2 -40 0 -40 5 0 11 -57 10 -82 -1 -9 -4
-29 -1 -45 7 -35 18 -131 39 -144 31 -17 -10 -9 12 14 35 20 23 22 31 16 110
-3 58 -1 91 6 101 44 56 34 134 -21 187 -55 52 -135 65 -223 38z m148 -26 c16
-15 18 -24 11 -50 -12 -40 -24 -54 -60 -69 -41 -17 -95 -5 -125 28 -30 32 -31
52 -7 83 32 39 142 44 181 8z m521 -483 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10
4 0 6 5 11 10 11 6 0 10 -2 10 -4z m-50 -30 c0 -2 -7 -7 -16 -10 -8 -3 -12 -2
-9 4 6 10 25 14 25 6z m-2260 -170 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0
6 5 11 10 11 6 0 10 -2 10 -4z"/>
<path d="M5830 5266 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"/>
<path d="M7806 5202 c-3 -5 4 -19 16 -32 19 -20 22 -21 30 -6 5 10 7 24 4 32
-6 15 -42 19 -50 6z"/>
<path d="M6368 5183 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4074 5105 c-58 -65 -120 -162 -111 -172 3 -2 13 8 23 24 42 70 80
121 117 160 23 24 38 45 35 48 -3 3 -32 -24 -64 -60z"/>
<path d="M7935 5030 c10 -11 20 -20 23 -20 3 0 -3 9 -13 20 -10 11 -20 20 -23
20 -3 0 3 -9 13 -20z"/>
<path d="M9123 4980 c-14 -6 -23 -18 -23 -30 0 -12 -17 -37 -37 -57 l-38 -35
33 18 c17 10 32 22 32 27 0 5 12 6 28 3 31 -7 44 0 61 32 10 18 10 27 0 38
-13 16 -24 17 -56 4z"/>
<path d="M5139 4953 c-13 -16 -12 -17 4 -4 9 7 17 15 17 17 0 8 -8 3 -21 -13z"/>
<path d="M7513 4823 c-9 -3 -13 -26 -13 -66 l0 -62 65 0 65 0 0 68 0 67 -52
-1 c-29 0 -59 -3 -65 -6z m92 -43 c3 -6 -1 -7 -9 -4 -18 7 -21 14 -7 14 6 0
13 -4 16 -10z"/>
<path d="M7674 4814 c3 -9 6 -38 6 -65 l0 -49 65 0 65 0 0 55 c0 65 -12 75
-90 75 -43 0 -51 -3 -46 -16z"/>
<path d="M5487 4803 c-3 -5 -7 -46 -9 -93 l-3 -85 98 -3 98 -3 -3 93 -3 93
-87 3 c-47 1 -89 -1 -91 -5z"/>
<path d="M5730 4715 l0 -95 100 0 101 0 -3 93 -3 92 -97 3 -98 3 0 -96z"/>
<path d="M9552 4683 c-7 -3 -19 -17 -26 -32 -10 -19 -27 -30 -62 -39 -44 -12
-65 -20 -134 -50 -24 -11 -24 -11 5 -6 17 3 65 15 109 26 62 17 82 19 97 10
25 -16 71 -15 91 1 26 20 28 44 7 71 -20 25 -54 32 -87 19z m53 -26 c18 -19 0
-47 -31 -47 -14 0 -23 4 -19 9 3 5 0 13 -6 17 -9 5 -7 11 6 21 23 16 33 16 50
0z"/>
<path d="M7499 4656 c-2 -2 -2 -36 -1 -76 l4 -72 61 4 62 3 3 70 3 70 -64 3
c-35 1 -65 0 -68 -2z"/>
<path d="M7678 4653 c-2 -5 -5 -36 -7 -70 l-3 -63 71 0 71 0 0 70 0 70 -64 0
c-36 0 -66 -3 -68 -7z"/>
<path d="M3970 4624 c-1 -43 142 -192 257 -268 84 -55 225 -126 251 -126 10 0
22 -4 28 -9 15 -15 240 -88 354 -115 526 -125 1197 -137 1825 -31 309 52 802
185 778 209 -4 4 0 4 8 1 8 -3 26 -1 40 4 21 9 21 10 4 11 -18 1 -18 2 5 16
17 10 19 13 5 9 -28 -10 -353 -95 -362 -95 -4 0 2 -7 13 -15 18 -13 17 -14
-19 -15 -28 0 -36 -3 -31 -12 4 -7 4 -10 0 -6 -4 3 -28 0 -53 -7 -61 -19 -41
0 27 25 63 23 45 22 -100 -5 -134 -25 -256 -43 -375 -54 -272 -26 -560 -43
-672 -39 -67 3 -120 1 -117 -4 3 -4 -16 -7 -43 -7 -43 1 -45 2 -18 9 28 7 27
8 -15 11 -78 5 -101 7 -275 33 -93 13 -190 29 -215 35 -25 6 -58 10 -75 10
-16 -1 6 -8 50 -17 64 -12 75 -17 55 -23 -19 -5 -20 -7 -6 -8 11 -1 17 -3 14
-6 -3 -4 -18 -3 -34 1 -26 7 -26 8 -9 16 12 5 -12 7 -63 5 -57 -3 -82 0 -79 7
3 7 -13 11 -40 12 -52 2 -101 23 -81 36 7 4 -18 6 -55 3 -37 -2 -66 -1 -63 3
2 4 -13 6 -35 4 -21 -2 -69 5 -108 17 -38 12 -78 21 -89 21 -11 0 -27 7 -36
15 -8 8 -22 15 -31 15 -9 0 -33 9 -55 20 -22 11 -46 20 -53 20 -8 0 -20 7 -27
15 -7 8 -20 15 -28 15 -14 0 -88 44 -102 61 -11 13 -80 18 -80 6 -1 -7 -5 -6
-13 4 -7 8 -19 18 -27 22 -8 4 -30 16 -49 28 -37 22 -56 18 -25 -6 10 -8 15
-15 10 -15 -6 0 -1 -7 10 -15 10 -8 16 -15 12 -15 -3 0 -28 20 -55 45 -26 25
-42 45 -35 45 6 0 12 -4 12 -10 0 -5 5 -10 10 -10 23 0 7 20 -25 31 -19 7 -35
19 -35 26 0 7 -4 13 -9 13 -5 0 -18 15 -30 33 -11 17 -21 27 -21 21z m2993
-461 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m-1740 -20 c-13
-2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z m134 1 c-3 -3 -12 -4 -19
-1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M5478 4523 c0 -27 -2 -61 -3 -78 -5 -73 -3 -75 101 -75 l94 0 0 100
0 100 -95 0 -95 0 -2 -47z"/>
<path d="M5730 4470 l0 -101 98 3 97 3 3 98 3 97 -101 0 -100 0 0 -100z"/>
<path d="M9225 4530 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"/>
<path d="M9158 4503 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7785 4420 c-8 -13 5 -13 25 0 13 8 13 10 -2 10 -9 0 -20 -4 -23 -10z"/>
<path d="M7710 4391 c-30 -10 -64 -23 -75 -29 -11 -6 -36 -16 -55 -21 -34 -10
-34 -10 11 -6 42 3 179 56 179 69 0 3 -1 6 -2 5 -2 0 -28 -9 -58 -18z"/>
<path d="M4708 4343 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4747 4329 c7 -7 15 -10 18 -7 3 3 -2 9 -12 12 -14 6 -15 5 -6 -5z"/>
<path d="M4810 4300 c8 -5 22 -9 30 -9 10 0 8 3 -5 9 -27 12 -43 12 -25 0z"/>
<path d="M4875 4280 c3 -5 24 -15 45 -21 22 -7 40 -18 40 -26 0 -7 5 -13 11
-13 5 0 7 4 4 10 -4 6 7 8 27 5 18 -3 4 4 -32 16 -36 11 -69 25 -74 30 -13 12
-29 12 -21 -1z"/>
<path d="M4928 4233 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3011 3595 c-182 -41 -299 -160 -331 -334 -19 -105 4 -210 61 -282
36 -45 117 -90 198 -109 100 -23 380 6 402 42 8 12 59 323 59 356 0 22 -2 22
-144 22 l-144 0 -7 -42 c-3 -24 -9 -51 -11 -60 -5 -16 2 -18 57 -18 l62 0 -7
-67 c-4 -38 -13 -74 -20 -81 -19 -20 -126 -27 -183 -13 -103 26 -150 98 -141
214 9 112 75 198 178 232 67 22 182 16 258 -14 64 -25 62 -25 62 -3 0 9 11 39
25 66 14 27 23 51 20 54 -2 2 -35 13 -72 24 -91 26 -240 32 -322 13z"/>
<path d="M5175 3511 c-3 -6 -9 -33 -12 -61 l-6 -50 66 0 c73 0 73 -1 79 80 l3
35 -62 3 c-34 2 -64 -2 -68 -7z"/>
<path d="M4340 3325 c-63 -18 -70 -26 -70 -79 0 -32 3 -37 18 -31 9 4 45 14
79 22 97 24 159 4 151 -49 -3 -21 -11 -24 -86 -35 -166 -23 -235 -65 -248
-149 -13 -88 54 -148 159 -141 44 2 67 10 100 34 43 30 44 30 53 9 12 -28 74
-50 118 -42 31 6 35 11 41 47 6 32 3 43 -11 53 -17 13 -17 18 -1 112 28 163
22 196 -45 234 -52 29 -179 37 -258 15z m161 -273 c-13 -46 -33 -71 -70 -88
-47 -22 -111 -5 -111 30 0 13 9 31 20 41 21 19 98 43 142 44 25 1 26 -1 19
-27z"/>
<path d="M4984 3321 c-23 -10 -49 -29 -58 -42 -17 -25 -19 -21 -16 24 1 27 1
27 -64 27 l-65 0 -6 -32 c-14 -82 -55 -338 -61 -380 l-6 -48 71 0 c39 0 71 3
71 8 0 4 9 62 19 130 21 131 39 170 91 197 16 8 47 15 68 15 38 0 40 2 46 38
11 71 9 82 -21 82 -16 0 -47 -9 -69 -19z"/>
<path d="M5580 3329 c-13 -6 -39 -21 -57 -35 l-33 -25 0 30 0 31 -63 0 -64 0
-33 -197 c-18 -109 -35 -213 -38 -230 l-4 -33 66 0 c60 0 66 2 70 23 3 12 14
75 25 140 27 155 55 197 134 197 43 0 70 -29 69 -72 -1 -31 -15 -128 -33 -221
-5 -26 -9 -52 -9 -58 0 -6 27 -9 67 -7 l67 3 23 145 c27 172 28 212 8 249 -28
54 -130 86 -195 60z"/>
<path d="M6098 3330 c-15 -4 -41 -18 -58 -30 l-32 -23 4 24 c3 22 -1 24 -51
27 -30 2 -57 0 -62 -5 -4 -4 -24 -109 -43 -233 -20 -124 -43 -264 -51 -311 -8
-48 -15 -90 -15 -93 0 -3 29 -6 65 -6 59 0 65 2 69 23 3 12 13 66 22 120 9 53
19 97 23 97 3 0 12 -9 18 -19 14 -23 71 -41 129 -41 53 0 135 42 169 87 54 70
74 207 41 284 -35 82 -137 127 -228 99z m85 -119 c30 -29 35 -124 9 -171 -42
-77 -125 -102 -181 -54 -27 23 -31 32 -31 77 0 64 32 132 74 159 38 24 100 19
129 -11z"/>
<path d="M6565 3333 c-11 -2 -41 -11 -67 -19 -48 -16 -48 -16 -48 -61 0 -39 2
-44 18 -38 94 39 172 44 207 15 16 -13 20 -55 7 -64 -5 -3 -49 -11 -99 -19
-162 -26 -223 -71 -223 -163 0 -122 176 -167 277 -72 18 17 23 18 23 6 0 -30
34 -48 92 -48 54 0 56 1 62 31 9 44 8 49 -8 49 -20 0 -23 17 -14 69 36 212 36
234 -9 275 -39 36 -146 55 -218 39z m107 -274 c-6 -42 -36 -83 -75 -102 -31
-16 -43 -17 -71 -7 -72 24 -51 90 37 114 106 30 113 29 109 -5z"/>
<path d="M3453 3303 c3 -15 20 -119 37 -230 l33 -203 73 0 73 0 73 152 73 151
11 -64 c6 -35 17 -103 24 -151 l13 -88 73 0 73 0 114 230 114 230 -71 0 -71 0
-65 -145 c-36 -79 -68 -141 -71 -137 -4 4 -14 69 -24 145 l-18 138 -70 -3 -71
-3 -73 -145 c-40 -80 -73 -143 -74 -140 -1 3 -9 68 -18 145 l-16 140 -74 3
-74 3 6 -28z"/>
<path d="M5136 3293 c-25 -162 -58 -373 -62 -396 l-6 -28 69 3 68 3 8 50 c49
297 63 391 60 398 -2 4 -33 7 -68 7 l-63 0 -6 -37z"/>
<path d="M9391 3134 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M9030 3054 c0 -2 15 -11 33 -20 27 -14 30 -15 19 -2 -11 14 -52 31
-52 22z"/>
<path d="M10121 3034 c-12 -27 -11 -28 4 -12 10 9 16 21 13 28 -2 7 -10 -1
-17 -16z"/>
<path d="M9682 3010 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z"/>
<path d="M9380 3004 c0 -13 18 -39 24 -34 2 3 -2 14 -10 24 -8 11 -14 16 -14
10z"/>
<path d="M8850 2970 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M8291 2944 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z"/>
<path d="M8938 2943 c12 -2 30 -2 40 0 9 3 -1 5 -23 4 -22 0 -30 -2 -17 -4z"/>
<path d="M9008 2943 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M9560 2926 c0 -8 -3 -21 -6 -30 -5 -14 3 -16 53 -16 46 0 60 3 60 15
0 8 -4 15 -9 15 -4 0 -8 -4 -8 -10 0 -5 -19 -10 -41 -10 -39 0 -41 2 -37 25 3
14 1 25 -3 25 -5 0 -9 -6 -9 -14z"/>
<path d="M8370 2922 c0 -5 7 -15 15 -22 8 -7 15 -8 15 -2 0 5 -7 15 -15 22 -8
7 -15 8 -15 2z"/>
<path d="M9485 2905 c-22 -13 -36 -25 -31 -25 10 0 76 39 76 46 0 7 -3 5 -45
-21z"/>
<path d="M10137 2908 c-21 -11 -36 -22 -33 -25 5 -6 63 24 71 37 3 5 5 9 3 9
-2 -1 -20 -11 -41 -21z"/>
<path d="M8952 2911 c-11 -7 -11 -9 0 -14 9 -3 15 1 15 9 0 8 -1 14 -1 14 -1
0 -7 -4 -14 -9z"/>
<path d="M9130 2910 c-8 -5 -12 -11 -9 -14 3 -3 14 1 25 9 21 16 8 20 -16 5z"/>
<path d="M8105 2900 c3 -5 11 -10 16 -10 6 0 7 5 4 10 -3 6 -11 10 -16 10 -6
0 -7 -4 -4 -10z"/>
<path d="M8850 2896 c14 -7 45 -16 70 -19 30 -4 38 -3 25 3 -11 5 -32 9 -47 9
-15 1 -30 6 -33 11 -3 6 -14 10 -23 10 -12 -1 -10 -5 8 -14z"/>
<path d="M9300 2903 c0 -16 48 -33 88 -32 35 1 35 2 -11 9 -27 5 -55 14 -63
20 -8 7 -14 8 -14 3z"/>
<path d="M9950 2890 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"/>
<path d="M9066 2881 c-4 -5 3 -7 14 -4 23 6 26 13 6 13 -8 0 -17 -4 -20 -9z"/>
<path d="M10023 2873 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M8908 2680 c-45 -14 -83 -41 -108 -78 -21 -29 -25 -48 -25 -103 0
-58 3 -71 25 -94 34 -37 79 -55 138 -55 75 0 112 16 112 48 0 33 -15 59 -24
43 -12 -20 -81 -32 -114 -20 -79 27 -54 173 34 195 15 4 46 2 68 -4 37 -10 43
-9 58 11 24 30 18 40 -28 54 -45 13 -98 15 -136 3z"/>
<path d="M9251 2680 c-125 -31 -185 -206 -98 -288 69 -64 204 -56 270 18 56
61 70 152 34 212 -28 46 -135 76 -206 58z m109 -80 c37 -37 19 -144 -29 -170
-37 -19 -88 -12 -110 16 -26 33 -27 68 -3 114 29 58 103 79 142 40z"/>
<path d="M9688 2666 c-36 -24 -38 -24 -38 -6 0 17 -7 20 -39 20 -38 0 -39 -1
-50 -47 -12 -55 -41 -235 -41 -258 0 -13 9 -15 42 -13 l43 3 15 99 c15 90 19
101 49 128 24 21 38 27 54 22 42 -13 43 -23 22 -144 -20 -115 -22 -110 28
-110 l43 0 13 88 c15 103 33 145 66 160 31 14 72 1 77 -25 2 -10 -4 -63 -14
-118 -10 -55 -18 -101 -18 -102 0 -2 20 -3 44 -3 l44 0 17 92 c28 143 26 174
-13 209 -20 18 -43 29 -62 29 -38 0 -90 -21 -109 -44 -13 -16 -16 -15 -41 9
-40 38 -87 42 -132 11z"/>
<path d="M3390 2630 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"/>
<path d="M8498 2633 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M8350 2619 c-59 -9 -125 -27 -100 -28 8 0 60 8 115 19 100 18 89 25
-15 9z"/>
<path d="M3438 2613 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7976 2573 c-1 -1 -103 -11 -226 -23 -248 -22 -277 -26 -286 -42 -5
-8 7 -9 36 -5 29 4 39 2 29 -4 -7 -5 -31 -9 -51 -9 -21 0 -38 -4 -38 -9 0 -6
15 -8 33 -6 17 3 91 12 162 20 144 18 218 32 175 34 -47 3 1 18 73 24 75 5 81
2 21 -12 -37 -10 -36 -10 16 -5 66 6 140 24 140 34 0 6 -77 9 -84 3z"/>
<path d="M8478 2563 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M3442 2555 c11 -11 265 -101 408 -145 88 -27 139 -39 355 -85 1002
-214 2231 -185 3610 86 110 21 229 46 265 54 36 8 137 32 225 52 88 20 153 39
144 40 -9 2 -122 -14 -250 -36 -129 -22 -301 -49 -384 -61 -82 -11 -175 -25
-205 -30 -259 -46 -894 -114 -1298 -140 -692 -43 -1150 -36 -1752 26 -343 36
-757 121 -1014 210 -104 35 -113 38 -104 29z m4655 -71 c-3 -3 -12 -4 -19 -1
-8 3 -5 6 6 6 11 1 17 -2 13 -5z m-104 -21 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12
5 14 0 19 -2 13 -5z"/>
<path d="M3675 2550 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M3791 2515 c6 -5 145 -35 162 -35 7 1 -6 7 -28 14 -41 14 -142 30
-134 21z"/>
<path d="M7355 2500 c3 -5 12 -10 20 -10 8 0 17 5 20 10 4 6 -5 10 -20 10 -15
0 -24 -4 -20 -10z"/>
<path d="M4038 2483 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M7000 2479 c-148 -13 -165 -18 -45 -12 127 5 262 20 185 20 -25 0
-88 -3 -140 -8z"/>
<path d="M4088 2473 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M7348 2468 c-8 -5 -2 -8 17 -8 17 0 36 4 43 8 8 6 2 9 -17 9 -17 0
-36 -4 -43 -9z"/>
<path d="M4168 2463 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M7298 2453 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4418 2443 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6524 2441 c3 -4 -31 -8 -77 -7 -100 1 -410 -15 -417 -22 -3 -2 87
-2 200 0 118 3 170 2 122 -2 -122 -11 -111 -19 19 -15 l114 4 -105 -10 c-58
-6 -132 -10 -165 -10 -42 -1 -54 -3 -40 -9 13 -6 -6 -9 -60 -11 -44 -1 -143
-5 -220 -8 -125 -7 -130 -8 -50 -9 125 -3 702 27 745 38 19 5 49 7 65 5 28 -4
28 -4 5 4 -14 5 -59 10 -100 10 -81 2 -80 11 5 37 l40 13 -43 0 c-24 1 -41 -3
-38 -8z"/>
<path d="M6938 2443 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M7203 2443 c9 -2 25 -2 35 0 9 3 1 5 -18 5 -19 0 -27 -2 -17 -5z"/>
<path d="M8600 2429 c-26 -48 7 -91 57 -73 24 8 28 16 31 52 l3 42 -40 0 c-30
0 -43 -5 -51 -21z"/>
<path d="M7005 2435 c-5 -2 -36 -6 -68 -10 -32 -4 -56 -9 -54 -12 9 -8 157 9
157 18 0 9 -16 11 -35 4z"/>
<path d="M7083 2433 c15 -2 37 -2 50 0 12 2 0 4 -28 4 -27 0 -38 -2 -22 -4z"/>
<path d="M4561 2426 c2 -2 21 -6 42 -10 27 -5 37 -4 32 3 -3 6 -22 11 -42 11
-20 0 -34 -2 -32 -4z"/>
<path d="M6840 2426 c0 -2 7 -6 15 -10 8 -3 15 -1 15 4 0 6 -7 10 -15 10 -8 0
-15 -2 -15 -4z"/>
<path d="M4670 2411 c19 -7 7 -9 -47 -10 -124 -2 -88 -17 70 -29 143 -11 220
-16 427 -26 l85 -4 -85 9 c-110 13 -142 21 -148 38 -4 11 7 13 54 8 34 -4 51
-3 39 2 -11 5 -110 11 -220 14 -115 4 -189 2 -175 -2z m163 -18 c-7 -2 -19 -2
-25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m65 0 c-10 -2 -26 -2 -35 0 -10 3 -2
5 17 5 19 0 27 -2 18 -5z"/>
<path d="M5885 2410 l-120 -6 128 -2 c79 -1 127 2 127 8 0 6 -3 9 -7 8 -5 -1
-62 -5 -128 -8z"/>
<path d="M4420 2406 c0 -2 14 -6 30 -8 17 -3 30 -1 30 4 0 4 -13 8 -30 8 -16
0 -30 -2 -30 -4z"/>
<path d="M5723 2403 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M6788 2403 c12 -2 32 -2 45 0 12 2 2 4 -23 4 -25 0 -35 -2 -22 -4z"/>
<path d="M5278 2393 c45 -2 119 -2 165 0 45 1 8 3 -83 3 -91 0 -128 -2 -82 -3z"/>
<path d="M6203 2393 c9 -2 23 -2 30 0 6 3 -1 5 -18 5 -16 0 -22 -2 -12 -5z"/>
<path d="M6728 2393 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5010 2379 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M5258 2343 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5338 2343 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M5688 2343 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
</g>
</svg>





    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
